import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '../../i18n';
export const FilterStatus = (props)=>{
    const { filteredItems, activePage, pageSize } = props;
    const pageStart = activePage * pageSize - pageSize + 1;
    const pageEnd = Math.min(pageStart + pageSize - 1, filteredItems);
    const pages = pageStart === pageEnd ? pageStart : `${pageStart}-${pageEnd}`;
    const { t } = useI18n();
    const showingNumRowsText = t('component.grid.pager.showingNumRows', {
        rows_visible: pages,
        rows_total: filteredItems
    });
    return /*#__PURE__*/ _jsx("div", {
        children: showingNumRowsText
    });
};
